import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard บังคับ first-time onboarding flow:
 * ถ้า `hasPurchasedPackage === false` (ร้านที่ยังไม่เคยซื้อ package เลย)
 * → redirect ไป `/owner/packages` ยกเว้น path ที่อยู่ใน allowlist
 *
 * Allowlist = หน้าที่ user ต้องเข้าถึงได้ระหว่าง lock: ซื้อแพ็กเกจ, edit profile, ดูร้าน, logout
 * หลังซื้อ package สำเร็จครั้งแรก → check-and-sync ตั้ง HasPurchasedPackage = true
 * → refreshFromToken → guard นี้ปล่อยผ่าน (ครั้งต่อไปไม่ lock แล้วแม้ package หมดอายุ)
 */
const ALLOWLIST = [
  '/owner/packages',
  '/owner/invoices',
  '/owner/company',
  '/owner/profile',
  '/owner/logout',
  '/owner/select-store',
  '/owner/start',
];

export const onboardingGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.currentUser();
  // ไม่ใช่ owner → guard นี้ไม่เกี่ยว
  if (user?.role !== 'owner') return true;
  // เคยซื้อ package แล้ว → ไม่ lock
  if (user.hasPurchasedPackage) return true;

  const path = state.url.split('?')[0];
  if (ALLOWLIST.some(p => path === p || path.startsWith(p + '/'))) return true;

  return router.createUrlTree(['/owner/packages']);
};
